export const normalizeAreaName = (str) => {
    if (!str) return '';
    return str
        .replace(/ونش-انقاذ-/g, '')
        .replace(/ونش انقاذ /g, '')
        .replace(/-/g, ' ')
        .replace(/[أإآ]/g, 'ا')
        .replace(/ة/g, 'ه')
        .replace(/[يى]/g, 'ي')
        .replace(/[٠۰]/g, '0')
        .replace(/[١۱]/g, '1')
        .replace(/[٢۲]/g, '2')
        .replace(/[٣۳]/g, '3')
        .replace(/[٤۴]/g, '4')
        .replace(/[٥۵]/g, '5')
        .replace(/[٦۶]/g, '6')
        .replace(/[٧۷]/g, '7')
        .replace(/[٨۸]/g, '8')
        .replace(/[٩۹]/g, '9')
        .replace(/\s+/g, ' ')
        .trim();
};

export const toAreaSlug = (str) => {
    if (!str) return '';
    return str
        .trim()
        .replace(/\s+/g, '-');
};
